module.exports = __webpack_public_path__ + "img/位图备份_13.d657fbfd.jpg";